module.exports = __webpack_public_path__ + "img/houseLighted.cd36f540.svg";